import { Expose, Type } from 'class-transformer';
import { BuildingModel } from '../models/building.model';
import { LocationModel } from '../models/location.model';

export class BuildingWithLocationModel extends BuildingModel {
  @Expose({ name: 'location' })
  @Type(() => LocationModel)
  location: LocationModel;
}
